var _circle, _rect, _path, _rect2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.997,
    cy: 31.997,
    r: 31.997,
    fill: "#F6BC00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.9501,
    y: 28.0363,
    width: 5.60277,
    height: 5.6,
    transform: "rotate(45 31.9501 28.0363)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5568 27.999L49.5186 31.9608L45.5588 35.9206L41.597 31.9588L45.5568 27.999Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3434,
    y: 28.0363,
    width: 5.60277,
    height: 5.6,
    transform: "rotate(45 18.3434 28.0363)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7878 24.7618L31.8083 17.6L38.8288 24.7618",
    stroke: "white",
    strokeWidth: 5.60277,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7878 38.4L31.8083 45.5618L38.8288 38.4",
    stroke: "white",
    strokeWidth: 5.60277,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/BNB.403de892bae0785a66ba0095c03dc39e.svg";
export { ForwardRef as ReactComponent };